module.exports = __webpack_public_path__ + "img/dingdingSing6.b610c8ad.png";